import React from 'react';

import { CardNumberElement } from '@stripe/react-stripe-js';
import type { StripeCardNumberElementChangeEvent } from '@stripe/stripe-js';

type Props = {
	onChange?: (event: StripeCardNumberElementChangeEvent) => unknown;
	onFocus?: () => void;
	onBlur?: () => void;
};

export const CardNumberElementWrapper: React.FC<Props> = ({ onChange, onFocus, onBlur }) => {
	return (
		<CardNumberElement
			options={{ style: { base: { fontSize: '16px' } } }}
			onChange={onChange}
			onFocus={onFocus}
			onBlur={onBlur}
		/>
	);
};
